export const types = {
  datePicker: 'datePicker',
  timePicker: 'timePicker',
  editableInput: 'editableInput',
  dropdownSelect: 'dropdownSelect',
  input: 'input',
  select: 'select',
  checkboxGroup: 'checkboxGroup',
  checkboxBtnGroup: 'checkboxBtnGroup',
  checkbox: 'checkbox',
  optionBtnGroup: 'optionBtnGroup',
  editor: 'editor',
  switch: 'switch',
  uploadDragger: 'uploadDragger',
  textarea: 'textarea',
};
